import axios from 'axios';
import Message from './plugins/Message';
import { isEmpty } from '@/helpers/utils';

export default baseURL => {
  const loginUrl =
    process.env.BUILD_TYPE === 'kaer' ? process.env.LOGIN_URL : location.origin + location.pathname + '#/login';
  const request = axios.create({
    baseURL,
    timeout: 60000,
    withCredentials: true, // cookie跨域必备
    headers: {
      'Content-Type': 'application/json'
    }
  });

  // http request 拦截器 Request
  request.interceptors.request.use(
    config => {
      // if (config && !config.ignoreLoading) {
      //   loadingShow();
      // }
      return config;
    },
    error => {
      return Promise.reject(error);
    }
  );

  // http response 拦截器 Response
  request.interceptors.response.use(
    response => {
      const { data: res } = response;
      // if (response.config && !response.config.ignoreLoading) {
      //   loadingClose();
      // }

      if (!res.ok) {
        const message = res.error ? res.error.message : res.message;
        if (!response.config.handleError) {
          Message({
            message,
            type: 'error',
            duration: 5000
          });
        }
        if (res?.error?.code === 'TOKEN_ERROR') {
          const location = window.location;
          location.href = loginUrl;
          location.reload();
        } else {
          return Promise.reject(res);
        }
      } else {
        return isEmpty(res.result) ? res.data : res.result;
      }
    },
    error => {
      // loadingClose();

      // 处理错误状态码 401， 403， 500等
      const response = error.response;
      if (!response) {
        // 无返回结果为网络异常
        Message({
          message: '网络请求失败',
          type: 'error',
          duration: 5000
        });

        return Promise.reject(error);
      }

      const message = response.data.error ? response.data.error.message : '请求错误';
      if (response.status === 401) {
        // if (response.config && !response.config.handleError) {
        //   Message({
        //     message,
        //     type: 'error',
        //     duration: 5000
        //   });
        // }

        // 被挤掉时，有弹窗存在，处理弹窗问题
        const location = window.location;
        location.href = loginUrl;
        location.reload();
      } else if (response.config && !response.config.handleError) {
        Message({
          message,
          type: 'error',
          duration: 5000
        });
      }
      return Promise.reject(error);
    }
  );

  return { request };
};
